import api from '@pray/shared/utils/api';
import type { CursorInfiniteQueryParams } from '@pray/shared/utils/api/types/fetch';

import { LeadsListResponse } from './types';

type GetLeadsListContactsProps = {
  artistId: string;
  listId: string;
  lastItemIdentifier?: string;
  search?: string;
  emailStatus?: string;
  sortDirection?: 'asc' | 'desc';
};

/*
  By default,
  - contacts are sorted by created_at;
  - and newest or oldest from last_item_identifier are by created_at as well.
*/
export async function getLeadsListLeads({
  artistId,
  listId,
  lastItemIdentifier,
  search = '',
  emailStatus,
  sortDirection = 'asc',
}: GetLeadsListContactsProps) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!listId) throw new Error('List ID is required');

  const params: CursorInfiniteQueryParams = {};

  if (search) {
    params.search = search;
  }

  if (emailStatus && emailStatus !== 'all') {
    params.email_status = emailStatus;
  }

  if (lastItemIdentifier) {
    params.last_item_identifier = lastItemIdentifier;
  }

  if (sortDirection) {
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/leads-lists/${listId}/leads`;
  const response = await api.executeGetRequest<LeadsListResponse>(url, params);

  return response.data;
}
